//Creates a new group
//Requires: name
//Accepts: description, hidden, private, ownerUid


export class Group {
    id ='';
    name = '';
    hidden = false;
    priv = false;
    ownerUid = '';
  
    constructor (id: string, name: string, hidden:boolean, ownerUid:string,priv:boolean){
        this.id = id;
        this.name = name;
        this.hidden = hidden;
        this.ownerUid=ownerUid;
        this.priv=priv;
     }

     //test
  }


// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/models/group.model.ts